import { useMemo } from 'react';
import { GiftVoucherSortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): GiftVoucherSortingField => {
    switch (field) {
        case 'giftCode':
            return GiftVoucherSortingField.GiftCode;

        case 'value':
            return GiftVoucherSortingField.Value;

        case 'status':
            return GiftVoucherSortingField.GiftVoucherStatus;

        case 'company':
            return GiftVoucherSortingField.Company;

        case 'purchaser.fullName':
            return GiftVoucherSortingField.Purchaser;

        case 'giftee':
            return GiftVoucherSortingField.Giftee;

        case 'purchasedDate':
            return GiftVoucherSortingField.PurchasedDate;

        default:
            throw new Error(`Unknown Sorting Field! Field: ${field}`);
    }
});

const useSortOrder = sort =>
    useMemo(
        () => ({
            giftCodeSort: sort.field === GiftVoucherSortingField.GiftCode ? sort.orderValue : undefined,
            valueSort: sort.field === GiftVoucherSortingField.Value ? sort.orderValue : undefined,
            giftVoucherStatusSort:
                sort.field === GiftVoucherSortingField.GiftVoucherStatus ? sort.orderValue : undefined,
            companySort: sort.field === GiftVoucherSortingField.Company ? sort.orderValue : undefined,
            purchaserSort: sort.field === GiftVoucherSortingField.Purchaser ? sort.orderValue : undefined,
            gifteeSort: sort.field === GiftVoucherSortingField.Giftee ? sort.orderValue : undefined,
            purchasedDateSort: sort.field === GiftVoucherSortingField.PurchasedDate ? sort.orderValue : undefined,
        }),
        [sort]
    );

export default useSortOrder;
